(function () {
  if (customElements.get('ultrapod-product')) return;

  class UltrapodProduct extends HTMLElement {
    connectedCallback() {
      try {
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      } catch (e) {
        this.variants = [];
      }
      this.idInput = this.querySelector('[data-variant-id]');
      this.form = this.querySelector('form');
      this.priceEl = this.querySelector('[data-price]');
      this.compareEl = this.querySelector('[data-compare]');
      this.saveEl = this.querySelector('[data-save]');
      this.addBtn = this.querySelector('[data-add]');
      this.addText = this.querySelector('[data-add-text]');
      this.addPrice = this.querySelector('[data-add-price]');

      this.addEventListener('change', this.onChange.bind(this));
      this.initGallery();
      this.initQuantity();
      this.initBooster();
      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    /* ---------- Variants ---------- */
    selectedOptions() {
      var inputs = this.querySelectorAll('.up__opt-input:checked');
      var out = [];
      inputs.forEach(function (i) {
        out[parseInt(i.getAttribute('data-option-index'), 10)] = i.value;
      });
      return out;
    }

    currentVariant() {
      var sel = this.selectedOptions();
      return this.variants.find(function (v) {
        return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
      });
    }

    onChange(e) {
      if (e.target.classList.contains('up__opt-input')) {
        this.updateVariant();
      } else if (e.target.hasAttribute('data-booster-variant')) {
        this.updateBoosterPrice();
      }
    }

    updateVariant() {
      // Update selected option labels
      var labels = this.querySelectorAll('[data-selected-option]');
      var sel = this.selectedOptions();
      labels.forEach(function (l) {
        var idx = parseInt(l.getAttribute('data-selected-option'), 10);
        if (sel[idx] !== undefined) l.textContent = sel[idx];
      });

      var v = this.currentVariant();
      if (!v) {
        if (this.addBtn) { this.addBtn.disabled = true; }
        if (this.addText) this.addText.textContent = 'Unavailable';
        if (this.addPrice) this.addPrice.textContent = '';
        return;
      }

      if (this.idInput) {
        this.idInput.value = v.id;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // Notify subscription / app blocks so their selling-plan widget tracks the variant
      var variantDetail = { variant: v };
      this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: variantDetail }));
      document.dispatchEvent(new CustomEvent('variant:changed', { detail: variantDetail }));

      if (this.priceEl) this.priceEl.textContent = v.price;
      if (this.compareEl) {
        if (v.compare) { this.compareEl.textContent = v.compare; this.compareEl.style.display = ''; }
        else { this.compareEl.style.display = 'none'; }
      }
      if (this.saveEl) {
        if (v.save) {
          var saveStyle = this.saveEl.getAttribute('data-save-style');
          this.saveEl.textContent = 'Save ' + (saveStyle === 'amount' ? v.save_amount : v.save + '%');
          this.saveEl.style.display = '';
        } else {
          this.saveEl.style.display = 'none';
        }
      }

      if (this.addBtn) this.addBtn.disabled = !v.available;
      var addLabel = (this.addBtn && this.addBtn.getAttribute('data-add-label')) || 'Add to Cart';
      if (this.addText) this.addText.textContent = v.available ? addLabel : 'Sold out';
      if (this.addPrice) this.addPrice.textContent = v.available ? v.price : '';

      // Custom images: let the colour filter surface the variant hero first.
      // Otherwise sync the native gallery to the variant's featured image.
      if (v.media_id && !this.hasCustom) this.scrollToMedia(v.media_id);
      this.filterGalleryByColor();

      // Update URL
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    /* ---------- Gallery ---------- */
    initGallery() {
      this.main = this.querySelector('[data-gallery-main]');
      if (!this.main) return;
      this.hasCustom = !!this.main.querySelector('[data-fp-color]');
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-dot]'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));
      var self = this;

      this.thumbs.forEach(function (t) {
        t.addEventListener('click', function () { self.goTo(parseInt(t.getAttribute('data-thumb'), 10)); });
      });
      this.dots.forEach(function (d) {
        d.addEventListener('click', function () { self.goTo(parseInt(d.getAttribute('data-dot'), 10)); });
      });

      var prev = this.querySelector('[data-gallery-prev]');
      var next = this.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { self.goTo(self.currentIndex() - 1); });
      if (next) next.addEventListener('click', function () { self.goTo(self.currentIndex() + 1); });

      this.main.addEventListener('scroll', function () {
        window.clearTimeout(self._st);
        self._st = window.setTimeout(function () { self.setActive(self.currentIndex()); }, 60);
      });

      // Apply colour filter for the preselected variant on load
      this.filterGalleryByColor();
    }

    currentIndex() {
      if (!this.main) return 0;
      var w = this.main.clientWidth || 1;
      var visPos = Math.round(this.main.scrollLeft / w);
      var slides = Array.prototype.slice.call(this.main.children);
      var count = 0;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-hidden')) continue;
        if (count === visPos) return i;
        count++;
      }
      return 0;
    }

    goTo(index) {
      if (!this.main) return;
      var slides = Array.prototype.slice.call(this.main.children);
      if (index < 0) index = 0;
      if (index > slides.length - 1) index = slides.length - 1;
      // Count visible slides before `index` (hidden slides collapse to 0 width)
      var before = 0;
      for (var i = 0; i < index; i++) {
        if (!slides[i].classList.contains('is-hidden')) before++;
      }
      this.main.scrollTo({ left: before * this.main.clientWidth, behavior: 'smooth' });
      this.setActive(index);
    }

    setActive(index) {
      this.dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      this.thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    }

    /* ---------- Custom-image gallery: filter by selected variant colour ---------- */
    filterGalleryByColor() {
      if (!this.main) return;
      var selected = this.selectedOptions().map(function (v) { return (v || '').toLowerCase().trim(); });
      var slides = Array.prototype.slice.call(this.main.children);
      var self = this;
      var firstVisible = -1;
      slides.forEach(function (slide, i) {
        var tag = (slide.getAttribute('data-fp-color') || '').toLowerCase().trim();
        var show = !tag || selected.indexOf(tag) !== -1;
        slide.classList.toggle('is-hidden', !show);
        if (self.dots[i]) self.dots[i].classList.toggle('is-hidden', !show);
        if (self.thumbs[i]) self.thumbs[i].classList.toggle('is-hidden', !show);
        if (show && firstVisible === -1) firstVisible = i;
      });
      if (firstVisible === -1) return;
      var cur = this.currentIndex();
      if (!slides[cur] || slides[cur].classList.contains('is-hidden')) {
        this.goTo(firstVisible);
      } else {
        this.setActive(cur);
      }
    }

    scrollToMedia(mediaId) {
      if (!this.main) return;
      var slides = Array.prototype.slice.call(this.main.children);
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') == mediaId; });
      if (idx >= 0) this.goTo(idx);
    }

    /* ---------- Quantity ---------- */
    initQuantity() {
      this.qtyInput = this.querySelector('[data-qty]');
      var minus = this.querySelector('[data-qty-minus]');
      var plus = this.querySelector('[data-qty-plus]');
      var self = this;
      if (minus) minus.addEventListener('click', function () { self.step(-1); });
      if (plus) plus.addEventListener('click', function () { self.step(1); });
    }

    step(dir) {
      if (!this.qtyInput) return;
      var val = parseInt(this.qtyInput.value, 10) || 1;
      val = Math.max(1, val + dir);
      this.qtyInput.value = val;
    }

    /* ---------- Booster ---------- */
    initBooster() {
      var el = this.querySelector('[data-booster]');
      if (!el) return;
      try { this.boosters = JSON.parse(el.textContent); } catch (e) { this.boosters = []; }
      this.updateBoosterPrice();
    }

    selectedBooster() {
      var checked = this.querySelector('[data-booster-variant]:checked') || this.querySelector('[data-booster-variant]');
      return checked ? checked.value : null;
    }

    updateBoosterPrice() {
      if (!this.boosters) return;
      var id = this.selectedBooster();
      var b = this.boosters.find(function (x) { return String(x.id) === String(id); });
      if (!b) return;
      var p = this.querySelector('[data-booster-price]');
      var c = this.querySelector('[data-booster-compare]');
      if (p) p.textContent = b.price;
      if (c) { if (b.compare) { c.textContent = b.compare; c.style.display = ''; } else { c.style.display = 'none'; } }
    }

    /* ---------- Add to cart (with optional booster) ---------- */
    onSubmit(e) {
      if (!window.IdyllCart) return; // no helper -> native submit fallback
      e.preventDefault();

      var qty = this.qtyInput ? parseInt(this.qtyInput.value, 10) || 1 : 1;
      var item = { id: this.idInput.value, quantity: qty };
      // Forward the selling plan chosen by a subscription app block, if any
      var spChecked = this.querySelector('[name="selling_plan"]:checked');
      var spVal = spChecked ? spChecked.value : null;
      if (!spVal) {
        var spSel = this.querySelector('select[name="selling_plan"], input[name="selling_plan"]');
        if (spSel) spVal = spSel.value;
      }
      if (spVal) item.selling_plan = spVal;
      var items = [item];
      var check = this.querySelector('[data-upsell-check]');
      if (check && check.checked) {
        var boosterId = this.selectedBooster();
        if (boosterId) items.push({ id: boosterId, quantity: 1 });
      }

      var btn = this.addBtn;
      if (btn) btn.setAttribute('aria-busy', 'true');
      window.IdyllCart.add(items).then(function () {
        if (btn) btn.removeAttribute('aria-busy');
      });
    }
  }

  customElements.define('ultrapod-product', UltrapodProduct);
})();
